import { Dispatch, FC, SetStateAction, useCallback, useState } from 'react';
import { Dialog } from '@ordr-as/umami-react/dialog';
import { TextInput } from '@ordr-as/umami-react/form';
import { useUpdateCartItems } from './cart-items/useUpdateCartItems';
import { OrderLineDto } from '../../../../../generated-api';

interface Props {
  orderLine: OrderLineDto;
  setShowQuantityDialog: Dispatch<SetStateAction<boolean>>;
}

const QuantityDialog: FC<Props> = ({ orderLine, setShowQuantityDialog }) => {
  const [inputQuantity, setInputQuantity] = useState(orderLine.quantity.toString());
  const updateCartItems = useUpdateCartItems();

  const handleSave = useCallback(() => {
    const diff = parseInt(inputQuantity) - orderLine.quantity;
    updateCartItems(diff, orderLine);

    setShowQuantityDialog(false);
  }, [inputQuantity, orderLine, setShowQuantityDialog, updateCartItems]);

  return (
    <Dialog
      className="w-6/12"
      title="Change Quantity"
      onAction={handleSave}
      isDisabledAction={inputQuantity.length < 1 || parseInt(inputQuantity) > 999}
      actionLabel="Save"
      onClose={() => setShowQuantityDialog(false)}
      alignTop
    >
      <TextInput
        label="How many?"
        required
        fullWidth
        value={inputQuantity}
        onChange={setInputQuantity}
        inputMode="numeric"
        type="number"
      />
    </Dialog>
  );
};

export default QuantityDialog;
